import React, { useState, useEffect } from 'react'
import api from '../components/api'
//import Accordion from 'react-bootstrap/Accordion';
import SaudePeloClima_AcoesLideranca from '../components/SaudePeloClima_AcoesLideranca'
import SaudePeloClima_DadosEmissoes from '../components/SaudePeloClima_DadosEmissoes'
import SaudePeloClima_Metas from '../components/SaudePeloClima_Metas'
import SaudePeloClima_Resiliencia from '../components/SaudePeloClima_Resiliencia'

import Correcoes from '../components/Correcoes'
import EmailCorrecoes from '../components/EmailCorrecoes'

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import moment from 'moment'


const Modal = (props) => {

    
    //var hospClima_id = props.hospClima_id
    var formulario_id = props.formulario_id
    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id

    


    const [totalCorrecoes, setTotalCorrecoes] = useState(0)
    const [totalEmails, setTotalEmails] = useState(0)

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()


    

    const verificaValidacoes = () => {

        //console.log(formulario_id, 'veri')
        

        if (formulario_id) {

            var dataPost = {

                formulario_id: formulario_id,
                desafio: 'Clima',

            }

            

            api.post('desafioValidaVarios', dataPost).then((result) => {

                if (result.data) {

                    setTotalCorrecoes(result.data.length)
                    
                }
                
              

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }

    function validaClima(opc) {

        var dataPost = {

            opc: opc,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            formulario_id: formulario_id,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma a ação?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
                    

                    api.put(`desafioClimaValida`, dataPost).then((result) => {
                        
                        //console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$("#modalDesafioClima").modal('hide');
                            
                            props.fnClima()

                        } else {

                            window.toastr.error(result.data.alerta)
                            return false
                        }

                        
                    }).catch((err) => {
                        console.log(err.response)
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }



    async function geraPDF() {


        api.get(`desafioclimaPDF/${adesao_institucional_id}/${ano}`).then((result) => {

            if (result.data.arquivo) {

                window.open(`${process.env.REACT_APP_URL}/pdf/${result.data.arquivo}`)

            } else {

                window.toastr.error(`Não foi possível gerar o PDF, provavelmente o preenchimento não está completo!`)
                return false

            }

        }).catch((err) => {

            console.log(err.response)

        })


    }



    const listaEmailsCorrecoes = () => {

        api.get(`emailsCorrecoesDesafio/${formulario_id}`).then((result) => {

            //console.log(result.data)
            setTotalEmails(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })

    }




    useEffect(() => {


        
        window.$('[href="#tabDC1"]').tab('show');


    }, [ano, formulario_id])



    useEffect(() => {

        verificaValidacoes()
        listaEmailsCorrecoes()

    }, [verificaDesafio, formulario_id])



    


    return (

        <div>


                <div className="modal fade" id="modalDesafioClima" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document"  style={{ width: '95%'}} >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Desafio Clima - Ano {ano}</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">


                                    <div class="row">
                                            
                                            <div class="col-sm-12">
                                                


                                                <ul class="nav nav-tabs">
                                                
                                                        <li class="active"><a href="#tabDC1" data-toggle="tab">Ações de Liderança</a></li>
                                                        <li><a href="#tabDC5" data-toggle="tab">Resiliência</a></li>
                                                        <li><a href="#tabDC2" data-toggle="tab">Emissões de GEE</a></li>
                                                        <li><a href="#tabDC3" data-toggle="tab">Metas</a></li>
                                                        <li><a href="#tabDC4" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                                                        <li><a href="#tabDC6" data-toggle="tab">E-mails ({totalEmails})</a></li>
                                                        
                                                </ul>

                                                <div class="tab-content">
                                                    <div class="tab-pane fade in active" id="tabDC1">
                                                        <div class="panel-body">

                                                            <SaudePeloClima_AcoesLideranca adesao_institucional_id={adesao_institucional_id}  ano={ano} formulario_id={formulario_id} />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabDC5">
                                                        <div class="panel-body">

                                                            <SaudePeloClima_Resiliencia adesao_institucional_id={adesao_institucional_id}  ano={ano}  formulario_id={formulario_id} />                                                

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabDC2">
                                                        <div class="panel-body">

                                                            <SaudePeloClima_DadosEmissoes adesao_institucional_id={adesao_institucional_id}  ano={ano} formulario_id={formulario_id} />                                                

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabDC3">
                                                        <div class="panel-body">

                                                            <SaudePeloClima_Metas adesao_institucional_id={adesao_institucional_id}  ano={ano} formulario_id={formulario_id} />                                                

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabDC4">
                                                        <div class="panel-body">

                                                            <Correcoes adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} ano={ano} origem="Clima" />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabDC6">
                                                        <div class="panel-body">

                                                            <EmailCorrecoes adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} ano={ano}  origem="Clima" />

                                                        </div>

                                                    </div>
                                                    
                                                </div>

                                            </div>

                                        </div>


                                    </div>


                            </div>
                            <div className="modal-footer">

                            <button type="button" className="btn btn-danger" onClick={() => geraPDF()}>PDF</button>

                                <button type="button" className="btn btn-info" onClick={() => validaClima('A')}>Em análise</button>
                                <button type="button" className="btn btn-danger" onClick={() => validaClima('P')}>Com pendências</button>
                                <button type="button" className="btn btn-primary" onClick={() => validaClima('V')}>Completo</button>
                                <button type="button" className="btn btn-warning" onClick={() => validaClima('Z')}>Verificado</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )



}


    

export default Modal